import {Location} from 'components/TimePicker/types';

const AustinImage = 'https://static.bodyspec.com/at/18/45/18450aa2b1bce87c';
// const BellevueImage = 'https://static.bodyspec.com/at/31/7b/317b0d18abb62d06';
const CAImage = 'https://static.bodyspec.com/at/f6/04/f60426c21d486f36';
const DallasImage = 'https://static.bodyspec.com/at/28/fb/28fb105a6bfd3c0d';
const LAImage = 'https://static.bodyspec.com/at/55/52/5552ebf80a717c3c';
const MobileImage = 'https://static.bodyspec.com/at/5a/0f/5a0f0794f8424c1d';
const NullImage = 'https://static.bodyspec.com/at/dc/f8/dcf80917ae9785c7';
const OCImage = 'https://static.bodyspec.com/at/91/54/91547309563bbff7';
const SFImage = 'https://static.bodyspec.com/at/d2/87/d28762812c0bf829';
const SeattleImage = 'https://static.bodyspec.com/at/c8/8f/c88fb8cafeef0717';

export const useBannerImage = (location?: Location): string => {
	switch(location?.regions.primary) {
	case undefined:
	case null:
		return NullImage;
	case 'austin':
		return AustinImage;
	case 'dallas':
		return DallasImage;
	case 'norcal':
		return SFImage;
	case 'seattle':
		return SeattleImage;
	case 'socal':
		switch(location?.details.name) {
		case 'BodySpec - Central LA':
			return LAImage;
		case 'BodySpec - Orange County':
			return OCImage;
		default:
			return CAImage;
		}
	default:
		return MobileImage;
	}
};
